import { BUSINESSES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import businessesTypes from '../../constants/businessesTypes'
import { axios } from '../../services'

//
const get_business_request = () => {
  return {
    type: businessesTypes.get.request
  }
}

const get_business_success = (response) => {
  return {
    type: businessesTypes.get.success,
    payload: response.data.business
  }
}

const get_business_failure = (messages) => {
  return {
    type: businessesTypes.get.failure,
    payload: messages
  }
}

const get_business = (business_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_business_request())

    // Request
    axios.get(
      formatRoute(BUSINESSES_ROUTES.get, {id: business_id})
    ).then( response => {
      // success
      dispatch( get_business_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching business."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_business_failure(errors))
    })
  }

}

export {
  get_business
}



// WEBPACK FOOTER //
// ./src/js/actions/businesses/get.js